import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

const MODULE_NAME = ModulesMap.MACHINE_FUEL_TANKS

export default class MachineFuelTanksApi extends ApiModule {
	constructor() {
		super(MODULE_NAME, {
			entity: 'fuel_tanks',
			parentEntity: 'machines',
		})
	}
}
